import { NavigateBefore, NavigateNext } from '@material-ui/icons';
import messages from 'components/Breadcrumbs/messages';
import {
  StyledBreadcrumbs,
  StyledDiv,
  StyledElementCaption,
  StyledRootCaption,
} from 'components/Breadcrumbs/styles';
import { isReverse, translate } from 'helpers/intl';
import { pushTo } from 'helpers/routes';
import { get } from 'lodash';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { useSelector } from 'react-redux';
import { breadcrumbsItemType } from 'store/global/types';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';

export type BreadcrumbsType = {
  path: breadcrumbsItemType[];
  intl: IntlShape;
  setBreadcrumbsPath?: Function;
};
const Breadcrumbs = (props: BreadcrumbsType) => {
  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);

  return (
    <StyledBreadcrumbs
      separator={
        reverse ? (
          <NavigateBefore fontSize="default" />
        ) : (
          <NavigateNext fontSize="default" />
        )
      }
      aria-label="breadcrumb"
    >
      {props.path.map((item: breadcrumbsItemType, index: number) => {
        if (index === props.path.length - 1)
          return (
            <StyledElementCaption key={index}>
              {translate(
                get(messages, get(props.path[props.path.length - 1], 'name')),
                props,
              )}
            </StyledElementCaption>
          );
        else
          return (
            <StyledDiv
              key={index}
              onClick={() => {
                if (props.setBreadcrumbsPath) {
                  const newPath = props.path.filter((item, j) => j <= index);
                  props.setBreadcrumbsPath(newPath);
                }
                if (item.route) return pushTo(item.route);
              }}
            >
              <StyledRootCaption>
                {translate(get(messages, item.name), props)}
              </StyledRootCaption>
            </StyledDiv>
          );
      })}
    </StyledBreadcrumbs>
  );
};

export default injectIntl(Breadcrumbs);
